﻿
var Crafted = Crafted || {};

Crafted.Validation = (function (ns, $) {

    ns.ValidateCkEditor = function (sender, args) {
        args.IsValid = false;

        var $container = $(sender).parent(".ckeditor");

        args.IsValid = $container.contents().find("iframe").contents().find("body").text().length > 0;

        if (args.IsValid) {
            $container.removeClass("field-error");
        } else {
            $container.addClass("field-error");
        }
    };

    return ns;
})(Crafted.Validation || {}, jQuery);